"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface InvTailoringQuestionsProps {
  onBack?: () => void;
}

const QUESTIONS: TailoringQuestion[] = [
  { 
    id: "Inv-1", 
    question: "Is any provision made/required to be made based on \"AS 2 – Inventories\" assessment of cost and net realizable value of inventory?", 
    type: "radio",
    options: ["Yes", "No"] 
  },
  { 
    id: "Inv-2", 
    question: "Does the entity have/is expected to have a material obsolete, slow-moving or excess adjustment/provision for inventory?", 
    type: "radio",
    options: ["Yes", "No"] 
  },
  { 
    id: "Inv-3", 
    question: "Does the entity have or is expected to have material goods-in-transit at period-end?", 
    type: "radio",
    options: ["Yes", "No"] 
  },
];

export default function InvTailoringQuestions({ onBack }: InvTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Inventory"
      title="Inventory - Tailoring Questions"
      description="Keep as provided."
      questions={QUESTIONS}
      onBack={onBack}
    />
  );
}



